import React, { useContext, useState } from 'react';
import { Formik } from 'formik';

import About from './Pages/About';
import CropSelection from './Pages/CropSelection';
import CropWaterUseTable from './Pages/CropWaterUseTable';
import LocationSelection from './Pages/LocationSelection';
import PageContainer from './PageContainer';

import { PageContext, pages } from '../../page-context';
import { LanguageContext } from '../../language-context';

import getSchema from './schema';
import lookupWaterUse from '../../utils/lookupWaterUse';
import getStations from './Pages/map-assets/stations';

const stations = getStations();

const initialValues = {
  crops: [],
  soilCode: '56',
  unit: 'ha',
  userCoords: {
    latitude: stations[0].coordinate.latitude + 0.5,
    longitude: stations[0].coordinate.longitude - 0.5,
  },
  weatherStation: 'chiguata',
};

function renderPage(
  actions,
  appStyles,
  language,
  pageNumber,
  toggleDisableNextStep,
  waterUse
) {
  switch (pageNumber) {
    case 1:
      return (
        <LocationSelection
          actions={actions}
          pageContent={pages[pageNumber + 1][language].fields}
          toggleDisableNextStep={toggleDisableNextStep}
        />
      );
    case 2:
      return (
        <CropSelection
          actions={actions}
          appStyles={appStyles}
          language={language}
          pageContent={pages[pageNumber + 1][language].fields}
          toggleDisableNextStep={toggleDisableNextStep}
        />
      );
    case 3:
      return (
        <CropWaterUseTable
          appStyles={appStyles}
          data={waterUse}
          irrigation={false}
          language={language}
          pageContent={
            pages[pageNumber + 1][language].fields[actions.values.unit]
          }
          unit={actions.values.unit}
        />
      );
    case 4:
      return (
        <CropWaterUseTable
          appStyles={appStyles}
          data={waterUse}
          irrigation={true}
          language={language}
          pageContent={
            pages[pageNumber + 1][language].fields[actions.values.unit]
          }
          unit={actions.values.unit}
        />
      );
    case 5:
      return (
        <About
          lang={language}
          pageContent={pages[pageNumber + 1][language].fields}
        />
      );
    default:
      return (
        <LocationSelection
          actions={actions}
          pageContent={pages[pageNumber + 1][language].fields}
          toggleDisableNextStep={toggleDisableNextStep}
        />
      );
  }
}

export default function Form({
  appStyles,
  setFormikActions,
  toggleDisableNextStep,
}) {
  const language = useContext(LanguageContext);
  const pageNumber = useContext(PageContext);

  const [waterUse, setWaterUse] = useState([]);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, actions) => {
        const waterUse = lookupWaterUse(values, language);
        setWaterUse(waterUse);
        actions.setSubmitting(false);
      }}
      validationSchema={getSchema(language)}
    >
      {(actions) => (
        <PageContainer
          actions={actions}
          setFormikActions={setFormikActions}
          title={
            typeof pages[pageNumber + 1][language].title === 'string'
              ? pages[pageNumber + 1][language].title
              : pages[pageNumber + 1][language].title[actions.values.unit]
          }
        >
          {renderPage(
            actions,
            appStyles,
            language,
            pageNumber,
            toggleDisableNextStep,
            waterUse
          )}
        </PageContainer>
      )}
    </Formik>
  );
}
